import React from 'react';
import { SelectOption } from '@/types/forms/select-option';
import { Autocomplete, TextField } from '@mui/material';

interface StandardAutocompleteProps {
  name: string;
  label: string;
  options: SelectOption[];
  value?: string | number;
  disabled?: boolean;
  placeholder?: string;
  error?: boolean;
  helperText?: string;
  onBlur?: React.FocusEventHandler<any>;
  onChange?: (value: string | number) => void;
  noOptionsText?: string;
  required?: boolean;
}

export const StandardAutocomplete = ({
  name,
  label,
  options,
  value,
  disabled,
  placeholder = 'Busca...',
  error,
  helperText,
  onBlur,
  onChange,
  noOptionsText = 'No hay opciones',
  required,
}: StandardAutocompleteProps) => {
  const selectedOption = options.find(option => option.value === value) || null;

  return (
    <Autocomplete
      options={options}
      value={selectedOption}
      getOptionLabel={(option: SelectOption) => option.label}
      noOptionsText={noOptionsText}
      ListboxProps={{ style: { maxHeight: '10rem' } }}
      fullWidth
      sx={{ marginBottom: '0.5rem' }}
      onChange={(_, newValue: SelectOption) => {
        onChange?.(newValue.value ? newValue.value : '');
      }}
      renderInput={params => (
        <TextField
          {...params}
          name={name}
          label={label}
          variant="outlined"
          placeholder={placeholder}
          disabled={disabled}
          onBlur={onBlur}
          error={error}
          helperText={helperText}
          required={required}
          InputLabelProps={{ style: { fontSize: '0.8em' } }}
          inputProps={{
            ...params.inputProps,
            style: { fontSize: '0.8em' },
          }}
        />
      )}
    />
  );
};
